import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import "./ErrorDialog.scss";

interface ErrorDialogProps {
  onClickHideModalHandler: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = (props) => {
  const { onClickHideModalHandler } = props;
  return (
    <div className="error-dialog-wrapper">
      <FontAwesomeIcon
        data-testid="fa-exclamation-triangle-icon"
        icon={faExclamationTriangle}
        size="2x"
        color="#C25506"
      />
      <div className="error-dialog__title">
        <h4>PDF Export Unavailable</h4>
        <div className="error-dialog__description">
          Error: We re sorry, pdf export is unavailable at the moment. Please
          try again later.
        </div>
      </div>
      <div className="close" onClick={onClickHideModalHandler}></div>
    </div>
  );
};

export default ErrorDialog;
